<template>
  <div class="flex flex-no-wrap flex-auto">
    <template v-if="!disabled">
      <flat-pickr class="form-control"
                  :class="[inputClass, {'rounded-r-none': clearable && !disabled}]"
                  :config="config"
                  :placeholder="placeholder"
                  @on-open="handleOnOpen"
                  @on-close="handleOnClose"
                  @on-change="handleOnChange"
                  v-model="model"
                  ref="flatpickr"/>
      <vue-button icon="close"
                  icon-class="svg-md"
                  :class="btnClass"
                  type="button"
                  class="btn btn-primary btn-outline text-gray rounded-l-none border-l-0 flex-no-shrink"
                  @click="clear"
                  v-if="clearable && !disabled"/>
    </template>

    <!-- This fix allows the input to display the date when the date is disabled and anterior of min date -->
    <vue-input v-else v-model="disabledInputText" :disabled="true"/>
  </div>
</template>

<script>
import FlatPickr from 'vue-flatpickr-component';
import { French } from 'flatpickr/dist/l10n/fr';
import flatpickr from 'flatpickr';

/**
 * Init Flatpickr.
 */
flatpickr.localize(French);
flatpickr.setDefaults({
  disableMobile: true,
  dateFormat: 'Y-m-d',
  altFormat: 'j F Y',
  altInput: true,
});

export default {
  components: { FlatPickr },

  props: {
    value: {
      required: true,
    },

    config: {
      type: Object,
      default: () => ({}),
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: null,
    },

    clearable: {
      type: Boolean,
      default: true,
    },

    inputClass: {
      type: String,
      default: null,
    },

    btnClass: {
      type: String,
      default: null,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    disabledInputText() {
      if (!this.value) {
        return null;
      }

      const date = flatpickr.parseDate(
        this.model,
        this.config.dateFormat || flatpickr.defaultConfig.dateFormat,
      );
      return flatpickr.formatDate(
        date,
        this.config.altFormat || flatpickr.defaultConfig.altFormat,
        French,
      );
    },
  },

  methods: {
    clear() {
      this.$refs.flatpickr.fp.clear();
    },

    handleOnOpen(selectedDates, dateStr, instance) {
      this.$emit('on-open', selectedDates, dateStr, instance);
    },

    handleOnClose(selectedDates, dateStr, instance) {
      /* Fix for mobile device where the user could not reopen
      the picker after close because the input does not loose focus */
      instance.input.blur();
      this.$emit('on-close', selectedDates, dateStr, instance);
    },

    handleOnChange(selectedDates, dateStr, instance) {
      this.$emit('on-change', selectedDates, dateStr, instance);
    },
  },
};
</script>
